/**
 * Deterministic lexical normalization for Party Search matching.
 * Matches the Search Broker philosophy: NFC, case-fold, punctuation-tolerant,
 * whitespace-collapsed. Does not invent transliterations or typos.
 */

const MAX_TOKENS = 40;
const MIN_TOKEN_LENGTH = 3;
const MIN_PREFIX_LENGTH = 3;

export function normalizeSearchText(value) {
  const text = typeof value === 'string' ? value.normalize('NFC') : '';
  if (!text) return '';
  const folded = text.toLowerCase();
  const stripped = folded.replace(/[^\p{L}\p{M}\p{N}\s]+/gu, ' ');
  return stripped.replace(/\s+/g, ' ').trim();
}

export function tokenizeNormalized(collapsed) {
  if (!collapsed) return [];
  const seen = new Set();
  const tokens = [];
  collapsed.split(' ').forEach((token) => {
    if (!token || seen.has(token)) return;
    if (tokens.length >= MAX_TOKENS) return;
    seen.add(token);
    tokens.push(token);
  });
  return tokens;
}

export function normalizePartySearchQuery(rawQuery) {
  const raw = typeof rawQuery === 'string' ? rawQuery : '';
  const collapsed = normalizeSearchText(raw);
  return {
    raw,
    collapsedWhitespace: collapsed,
    tokens: tokenizeNormalized(collapsed),
  };
}

export function textMatchesNormalizedQuery(text, normalizedQuery) {
  const haystack = normalizeSearchText(text);
  const needle = normalizedQuery?.collapsedWhitespace;
  if (!haystack || !needle) return null;
  if (haystack === needle) return 'exact';
  if (needle.length >= MIN_PREFIX_LENGTH && haystack.startsWith(needle)) {
    return 'prefix';
  }
  const hayTokens = new Set(tokenizeNormalized(haystack));
  const tokenHit = (normalizedQuery.tokens || []).some((token) => (
    token.length >= MIN_TOKEN_LENGTH && hayTokens.has(token)
  ));
  return tokenHit ? 'token' : null;
}
